import { CustomPalette } from "../mui-types";

export const buttonStyle = (palette: CustomPalette) => ({
  //Variants
  main: {
    backgroundColor: palette.Pink,
    color: palette.White.white,
    textTransform: "none",
    textAlign: "center",
    borderRadius: "12px",
    gap: "8px",
    width: "100%",
    "&:hover": {
      background: `linear-gradient(0deg, rgba(0, 0, 0, 0.12) 0%, rgba(0, 0, 0, 0.12) 100%), ${palette.Pink}`,
    },
    "&:focus": {
      outline: "none",
      boxShadow: "none",
    },
    "&:active": {
      background: palette.Pink,
      boxShadow: "none",
    },
    "&:disabled": {
      color: palette.White.white,
      opacity: 0.56,
    },
    "& .MuiButton-startIcon": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
  },
  secondary: {
    backgroundColor: palette.White.white,
    color: palette.Black[2],
    textTransform: "none",
    borderRadius: "12px",
    width: "100%",
    "&:hover": {
      backgroundColor: "#E0E0E0",
    },
    "&:disabled": {
      opacity: 0.56,
    },
    "& .MuiButton-startIcon": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
  },

  //Sizes
  small: {
    paddingTop: "5px",
    paddingBottom: "5px",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
    maxHeight: "32px",
  },
  medium: {
    paddingTop: "10px",
    paddingBottom: "10px",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "24px",
    maxHeight: "45px",
  },
  large: {
    paddingTop: "16px",
    paddingBottom: "16px",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "24px",
    maxHeight: "55px",
  },

  //OwnProps
  textOnlyPrimary: {
    backgroundColor: "transparent",
    textTransform: "none",
    color: palette.Pink,
    "&:hover": {
      opacity: 0.12,
    },
    "&:disabled": {
      opacity: 0.56,
    },
  },
  textOnlySecondary: {
    backgroundColor: "transparent",
    textTransform: "none",
    color: palette.White.white,
    "&:hover": {
      opacity: 0.12,
    },
    "&:disabled": {
      opacity: 0.56,
    },
  },
  pinkGradient: {
    background: "linear-gradient(90deg, #E83571 0%, #A51646 100%)",
    "&:hover": {
      background: "linear-gradient(90deg,#D7246C 0%, #D40C4F 100%)",
    },
  },
  purpleGradient: {
    background: `linear-gradient(90deg, #8E44EC 0%, #512786 100% )`,
    "&:hover": {
      background: `linear-gradient(90deg, #621BBE 0%, #360970 100% )`,
    },
  },
  rounded: {
    borderRadius: "50%",
  },
});

export const IconButtonsStyle = (palette: CustomPalette) => ({
  primary: {
    padding: "10px",
    height: "40px",
    width: "40px",
    borderRadius: "8px",
    background: palette.Black[3],
    color: palette.White.white,
    justifyContent: "center",
    alignItems: "center",
    "&:hover": {
      opacity: 1,
      background:
        "linear-gradient(0deg, rgba(255, 255, 255, 0.16) 0%, rgba(255, 255, 255, 0.16) 100%), #292929",
    },
    "&:disabled": {
      opacity: 0.56,
    },
    "& .MuiSvgIcon-root": {
      fill: palette.White.white,
      width: "18px",
      height: "18px",
    },
  },
  secondary: {
    padding: "12px",
    maxHeight: "48px",
    maxWidth: "48px",
    width: "100%",
    height: "100%",
    borderRadius: "50%",
    background: "rgba(62, 62, 62, 0.24)",
    color: palette.White.white,
    backdropFilter: "blur(8px)",
    "&:hover": {
      backgroundColor: "rgba(97, 97, 97, 0.7)",
    },
    "&:active": {
      backgroundColor: "rgba(97, 97, 97, 0.7)",
      "& .MuiSvgIcon-root": {
        fill: palette.White.white,
        width: "20px",
        height: "20px",
      },
    },
    "& .MuiSvgIcon-root": {
      fill: palette.White.white,
      width: "20px",
      height: "20px",
    },
  },
  active: {
    background: palette.White.white,
    transition: "background 0.2s ease-in-out",

    "&:hover": {
      background: "#E0E0E0",
    },
    "&:active": {
      background: "#E0E0E0",
    },
    "& .MuiSvgIcon-root": {
      fill: palette.Black[2],
      width: "18px",
      height: "18px",
    },
  },
  bigIcon: {
    padding: "8px",
    "& .MuiSvgIcon-root": {
      width: "24px",
      height: "24px",
    },
  },
  leftRadius: {
    borderTopLeftRadius: "8px",
    borderBottomLeftRadius: "8px",
    borderTopRightRadius: "0",
    borderBottomRightRadius: "0",
    borderRight: `solid 1px ${palette.White[56]}`,
  },
  rightRadius: {
    borderTopLeftRadius: "0",
    borderBottomLeftRadius: "0",
    borderTopRightRadius: "8px",
    borderBottomRightRadius: "8px",
    borderLeft: `solid 1px ${palette.White[56]}`,
  },
  topRadius: {
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
    borderBottomLeftRadius: "0",
    borderBottomRightRadius: "0",
    borderBottom: `solid 1px ${palette.White[56]}`,
  },
  bottomRadius: {
    borderTopLeftRadius: "0",
    borderTopRightRadius: "0",
    borderBottomLeftRadius: "8px",
    borderBottomRightRadius: "8px",
    borderTop: `solid 1px ${palette.White[56]}`,
  },
  square: {
    borderRadius: "0",
  },
});
